import { Message } from "../types";

export type RoomRequestSnapshot = {
  requestRoomId: string;
  requestGeneration: number;
  currentRoomId: string;
  currentGeneration: number;
  aborted: boolean;
};

export const shouldApplyRoomResponse = ({
  requestRoomId,
  requestGeneration,
  currentRoomId,
  currentGeneration,
  aborted,
}: RoomRequestSnapshot) =>
  !aborted &&
  requestRoomId === currentRoomId &&
  requestGeneration === currentGeneration;

export const sortMessages = (rows: Message[]) =>
  [...rows].sort((a, b) => {
    const time = a.created_at.localeCompare(b.created_at);
    return time || a.id.localeCompare(b.id);
  });

export const mergeMessages = (current: Message[], incoming: Message[]) => {
  const byId = new Map<string, Message>();
  current.forEach((message) => byId.set(message.id, message));
  incoming.forEach((message) => byId.set(message.id, message));
  return sortMessages(Array.from(byId.values()));
};
